import React from 'react';
import { ExtensionStatus, Presence, ExtensionSubStatus, CallState, CallType } from '../model';
import { ReactComponent as RingingOutbound } from './icons/callstatus/ringing-outbound.svg';
import { ReactComponent as RingingInbound } from './icons/callstatus/rining-inbound.svg';
import { ReactComponent as QueueOffHookOutbound } from './icons/callstatus/queue-off-hook-outbound.svg';
import { ReactComponent as QueueOffHookInbound } from './icons/callstatus/queue-off-hook-inbound.svg';
import { ReactComponent as OffHookOutbound } from './icons/callstatus/off-hook-outbound.svg';
import { ReactComponent as OffHookInbound } from './icons/callstatus/off-hook-inbound.svg';
import { ReactComponent as Queuing } from './icons/callstatus/queuing.svg';
import { ReactComponent as QueueHold } from './icons/callstatus/queue-hold.svg';
import { ReactComponent as Hold } from './icons/callstatus/on-hold.svg';
import { ReactComponent as Unattended } from './icons/callstatus/unattended.svg';
import { ReactComponent as Wrapup } from './icons/callstatus/wrapup.svg';
import { ReactComponent as InVoicemail } from './icons/callstatus/invoicemail.svg';

import { HasClassName } from '../component-utils';
import { getCallStatus } from './CallPopup';

interface Props extends HasClassName {
  presence?: Presence,
  status?: ExtensionStatus,
  subStatus?: ExtensionSubStatus
  callStatus?: CallState,
  callType?: CallType,
  title?: string | boolean,
  onClick?(e: React.MouseEvent): void
}

export default function CallStatusIcon({ className, presence, status, subStatus, callStatus, callType, title, onClick }: Props) {
  if (presence !== undefined && status !== undefined && subStatus !== undefined) {
    return React.cloneElement(getCallStatusIcon(presence, status, subStatus, title, onClick), { className });
  } else if (callStatus !== undefined && callType !== undefined) {
    return React.cloneElement(getCallStatusIconByCallStatus(callStatus, callType, title, onClick), { className });
  } else {
    console.error('CallStatusIcon not used correct');
    return <></>
  }
}


function getCallStatusIcon(presence: Presence, status: ExtensionStatus, subStatus: ExtensionSubStatus, title?: string | boolean, onClick?: (e: React.MouseEvent) => void) {
  function handleClick(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (onClick) {
      onClick(e)
    }
  }

  const pointer = { cursor: 'pointer' }

  switch (status) {
    case ExtensionStatus.Ringing:

      if (subStatus === ExtensionSubStatus.Outgoing) {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Hang up'} onClick={onClick && handleClick} style={pointer} ><RingingOutbound /></div>
      }

      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Ringing'} onClick={onClick && handleClick} style={pointer} ><RingingInbound /></div>

    case ExtensionStatus.Answered:
      if (presence === Presence.Queue) {

        if (subStatus === ExtensionSubStatus.Outgoing) {
          return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off Hook'} onClick={onClick && handleClick} style={pointer} ><QueueOffHookOutbound /></div>
        }

        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off Hook'} onClick={onClick && handleClick} style={pointer} ><QueueOffHookInbound /></div>

      } else {

        if (subStatus === ExtensionSubStatus.Outgoing) {
          return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off Hook'} onClick={onClick && handleClick} style={pointer} ><OffHookOutbound /></div>
        }

        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Answered'} onClick={onClick && handleClick} style={pointer} ><OffHookInbound /></div>

      }
    case ExtensionStatus.OffHook:

      if (subStatus === ExtensionSubStatus.Outgoing) {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Hang up'} onClick={onClick && handleClick} style={pointer} ><OffHookOutbound /></div>
      }

      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Hang up'} onClick={onClick && handleClick} style={pointer} ><OffHookInbound /></div>

    case ExtensionStatus.Hold:

      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'On Hold'} onClick={onClick && handleClick} style={pointer} ><Hold /></div>

    case ExtensionStatus.Dialed:

      if (subStatus === ExtensionSubStatus.Outgoing) {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Outbound'} onClick={onClick && handleClick} style={pointer} ><RingingOutbound /></div>
      }

      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Ringing'} onClick={onClick && handleClick} style={pointer} ><OffHookInbound /></div>

    default:

      console.error('Unknown status ' + status)
      return <></>
  }
}

function getCallStatusIconByCallStatus(callStatus: CallState, callType: CallType, title?: string | boolean, onClick?: (e: React.MouseEvent) => void) {
  function handleClick(e: React.MouseEvent) {
    e.preventDefault()
    e.stopPropagation()

    if (onClick) {
      onClick(e)
    }
  }

  const pointer = { cursor: 'pointer' }

  switch (callStatus) {
    case CallState.ExtensionPending:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Ringing'} onClick={onClick && handleClick} style={pointer}><RingingInbound /></div>

    case CallState.Queueing:
    case CallState.AnnouncementAnswered:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Queuing'} onClick={onClick && handleClick} style={pointer}><Queuing /></div>


    case CallState.ExtensionAnswered:
      if (callType === CallType.Queue) {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off hook'} onClick={onClick && handleClick} style={pointer}><QueueOffHookInbound /></div>
      } else if (callType === CallType.Outgoing) {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off hook'} onClick={onClick && handleClick} style={pointer}><QueueOffHookOutbound /></div>
      } else {
        return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off hook'} onClick={onClick && handleClick} style={pointer}><OffHookInbound /></div>
      }

    case CallState.QueueHold:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Parked'} onClick={onClick && handleClick} style={pointer}><QueueHold /></div>

    case CallState.Hold:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'On hold'} onClick={onClick && handleClick} style={pointer}><Hold /></div>

    case CallState.Callback:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Ringing'} onClick={onClick && handleClick} style={pointer}><RingingOutbound /></div>

    case CallState.OutboundOffHook:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Off hook'} onClick={onClick && handleClick} style={pointer}><OffHookOutbound /></div>

    case CallState.OutboundRinging:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Ringing'} onClick={onClick && handleClick} style={pointer}><RingingOutbound /></div>

    case CallState.Unattended:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Queue is closed'} onClick={onClick && handleClick} style={pointer}><Unattended /></div>

    case CallState.WaitingForWrapup:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Waiting foir wrapup'} onClick={onClick && handleClick} style={pointer}><Wrapup /></div>

    case CallState.CallInVoicemail:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Waiting foir wrapup'} onClick={onClick && handleClick} style={pointer}><InVoicemail /></div>

    case CallState.UnattendedProcessing:
      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : 'Unattending Processing'} onClick={onClick && handleClick} style={pointer}><Queuing /></div>

    case CallState.None:
      return <div onClick={onClick && handleClick} style={pointer}><Queuing /></div>

    default:

      return <div title={typeof title === 'boolean' ? '' : title !== undefined ? title : getCallStatus(callStatus)} onClick={onClick && handleClick} style={pointer}><Queuing /></div>

  }
}
